export enum ZIndex {
    Below = -1,
    Bottom = 1,
    Middle = 2,
    Top = 3,
    Overlay = 100,
    Header = 200,
    HeaderButton = 210,
    GlobalMessaging = 400,
    Menu = 500,
    AppHeader = 600,
    Notifications = 1500,
    Modal = 2000,
    DropdownMenu = 2500,
    // Above the gluestack `OverlayProvider` host (z-index 9999) — for legacy
    // ReactModal dialogs launched from *within* a universal Drawer (e.g. the
    // messaging send-confirmation), which must sit above the drawer's overlay.
    AboveAppOverlay = 10001,
    // Tooltips portal to `document.body`, so they have to clear the gluestack
    // overlay host too — otherwise a tooltip triggered inside a universal
    // Modal (e.g. the ATC map-layers panel) paints behind it and looks empty.
    Tooltip = 10002,
}
